import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';

const EventContext = createContext();

export const useEvent = () => {
    return useContext(EventContext);
};

export const EventProvider = ({ children }) => {
    const [event, setEvent] = useState([]);

    // Must keep a stable identity: consumers key effects on it, and a fresh function per
    // emitted event re-fires every one of them.
    const emitEvent = useCallback((action) => {
        setEvent(prev => [...prev, action]); // accumulate events.
    }, []);

    return (
        <EventContext.Provider value={{ event, emitEvent }}>
            {children}
        </EventContext.Provider>
    );
};

export function useEventAction(action, handler) {
    const { event } = useEvent();
    
    // START AT CURRENT LENGTH:
    // This tells the component to ignore every event that happened 
    // before this specific instance of the Quiz was mounted.
    const cursor = useRef(event.length);

    useEffect(() => {
        while (cursor.current < event.length) {
            const evt = event[cursor.current++];
            if (evt?.action === action) {
                handler(evt);
            }
        }
    }, [event, action, handler]);
}
